import { AdminSlideList } from "pwapi";

import { SlideAdminWithUrls } from "./adminSlideReducer";
import {
  ADMIN_SLIDES_SUCCESS,
  ADMIN_SLIDES_FAILURE,
  ADMIN_SLIDES_REQUEST,
  ADMIN_UPDATE_SLIDE_REQUEST,
  ADMIN_UPDATE_SLIDE_CASES_FAILURE,
  ADMIN_UPDATE_SLIDE_SUCCESS,
  ADMIN_DELETE_SLIDE_SUCCESS,
  ADMIN_SLIDE_BARCODE_SET,
  ADMIN_SLIDE_MACRO_SET,
  SET_LAST_ADMIN_SLIDE_VIEWED,
  ADMIN_SLIDE_SUCCESS,
  ADMIN_SLIDE_FAILURE,
} from "../../actions/adminConstants";

export type AdminSlideListDetail = SlideAdminWithUrls & {
  detailLoaded: boolean;
  detailError: boolean;
};

export interface AdminSlidesState {
  count?: number;
  next?: string;
  previous?: string;
  results: Array<AdminSlideList | AdminSlideListDetail>;
  loading?: boolean;
  lastViewed?: number;
}

export const initialState = {
  results: [],
};

let i;

const reducer = (state: AdminSlidesState = initialState, action: any): any => {
  switch (action.type) {
    case ADMIN_SLIDE_SUCCESS:
      i = state.results.findIndex((c) => c.id === action.payload.response.id);
      if (i < 0) return state;
      return {
        ...state,
        results: state.results.slice(0, i).concat(
          [
            {
              ...action.payload.response,
              detailLoaded: true,
              detailError: false,
            },
          ],
          state.results.slice(i + 1)
        ),
      };
    case ADMIN_SLIDE_FAILURE:
      i = state.results.findIndex((c) => c.id === action.args);
      if (i < 0) return state;
      return {
        ...state,
        results: state.results.slice(0, i).concat(
          [
            {
              ...state.results[i],
              detailLoaded: !!(state.results[i] as AdminSlideListDetail)
                .detailLoaded,
              detailError: true,
            },
          ],
          state.results.slice(i + 1)
        ),
      };
    case SET_LAST_ADMIN_SLIDE_VIEWED:
      return {
        ...state,
        lastViewed: action.payload,
      };
    case ADMIN_SLIDES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADMIN_SLIDES_SUCCESS:
      return {
        ...state,
        ...action.payload.response,
        loading: false,
      };
    case ADMIN_SLIDES_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ADMIN_SLIDE_BARCODE_SET:
      return {
        ...state,
        results: state.results.map((slide) => {
          return slide.id === action.payload.slideId
            ? {
                ...slide,
                barcode_url: action.payload.url,
              }
            : slide;
        }),
      };
    case ADMIN_SLIDE_MACRO_SET:
      return {
        ...state,
        results: state.results.map((slide) => {
          return slide.id === action.payload.slideId
            ? {
                ...slide,
                macro_url: action.payload.url,
              }
            : slide;
        }),
      };
    case ADMIN_UPDATE_SLIDE_REQUEST:
      return {
        ...state,
        results: state.results.map((slide) => {
          return slide.id === action.payload.slide.id
            ? {
                ...slide,
                isLoading: true,
              }
            : slide;
        }),
      };
    case ADMIN_UPDATE_SLIDE_CASES_FAILURE:
      return {
        ...state,
        results: state.results.map((slide) => {
          return slide.id === action.payload.slide.id
            ? {
                ...slide,
                isLoading: false,
              }
            : slide;
        }),
      };
    case ADMIN_UPDATE_SLIDE_SUCCESS:
      return {
        ...state,
        results: state.results.map((slide) => {
          return slide.id === action.payload.id
            ? {
                ...slide,
                ...action.payload,
                isLoading: false,
              }
            : slide;
        }),
      };

    case ADMIN_DELETE_SLIDE_SUCCESS:
      return {
        ...state,
        results: state.results.filter((slide) => {
          return slide.id !== action.payload.slide_id;
        }),
      };
    default:
      return state;
  }
};

export default reducer;
